import ApiService from './api.service'
import axios from 'axios'

const PosService = {
	/**
	 * SAVDONI FRONT ENDDA HISOB KITOBINI QILIB OXIRIDA BACK ENDGA YUBORADIGAN QILISH UCHUN
	 * QO'SHILDI BU FUNKTSIYA('fetchPosSearchItems') 12.05.2020 (BAXTIYOR ADDED FROM GLOBAL_TASHKENT BRANCH)
	 */
	fetchPosSearchItems: function (depId, keyword) {
		return ApiService.get(`pricing-item/search-pos-items/${depId}/${keyword}`);
	},

	getContrcactorByType: function (type) {
		return ApiService.get(`references/${type}/list`);
	},
	getContragentByContractorType:function (payload){
		return ApiService.post(`contragent/search`, payload)
	},
	saleCreated : function (depId,cashId){
		return ApiService.get(`/sale/suspended_list/${depId}/${cashId}`)
	},
	saleEdit : function (saleId) {
		return ApiService.get(`/sale/suspended_saleItems/${saleId}`)
	},
	saleDelete : function (saleId){
		return ApiService.get(`/sale/suspended_deletedSaleDocument/${saleId}`)
	},

	/**
	 * SAVDONI FRONT ENDDA HISOB KITOBINI QILIB OXIRIDA BACK ENDGA YUBORADIGAN QILISH UCHUN
	 * QO'SHILDI BU FUNKTSIYA('fetchWholesaleSearchItems') 12.05.2020 (BAXTIYOR ADDED FROM GLOBAL_TASHKENT BRANCH)
	 */
	fetchWholesaleSearchItems: function (keyword) {
		return ApiService.get(`pricing-item/search-wholesale-items/${keyword}`);
	},

	setLatestPrices: function (payload) {
		return ApiService.post(`/sale-item/correct-wh-pricingitems/${payload.saleId}`, payload.priceChangedItems);
	},
	finishSale: function (finish) {
		return ApiService.post('/sale/finishChek', finish);
	},
	finishSale1: function (finish) {
		return ApiService.post('/sale/finish', finish);
	},
	salePriceList: function (data) {
		return ApiService.post(`/sale/price-list/${data.depId}`, data.items);
	},
	salePriceListGet: function (saleId) {
		return ApiService.get(`/sale/price-list-sale/${saleId}`);
	},
	getDrafts: function () {
		return ApiService.get('/sale/list-of-drafts')
	},
	getSuspends: function () {
		return ApiService.get('/sale/list-suspended')
	},
	getSuspendsForWholesale: function () {
		return ApiService.get('/sale/list-suspended-whole')
	},
	getPricingList: function () {
		return ApiService.get('/pricing/list-percent')
	},
	createSaleDraftService: function (emptyObject, cashboxId, depId) {
		return ApiService.post(`/sale/create/${cashboxId}/${depId}`, emptyObject);
	},
	editSaleDraft: function (sale) {
		return ApiService.put(`/sale/edit/${sale.id}`, sale);
	},
	editSaleDraftOptom: function (sale) {
		return ApiService.put(`/sale/editOptom/${sale.id}`, sale);
	},
	editWholesaleService: function (sale) {
		return ApiService.put(`/sale/optom-edit/${sale.id}`, sale);
	},
	currencyConvertService: function (sale) {
		return ApiService.post(`/sale/optom-convert/${sale.id}`, sale);
	},
	suspendSaleService: function (sale) {
		return ApiService.put(`/sale/suspended/${sale.id}`, sale);
	},
	editForPosDraft: function (sale) {
		return ApiService.get(`/sale/get/${sale.id}`);
	},
	editPosWholeSale: function (sale) {
		return ApiService.get(`/sale/wholeget/${sale.id}`);
	},
	getSaleWithId: function (saleId) {
		return ApiService.get(`/sale/get/${saleId}`);
	},
	deleteSuspendSaleService: function (itemId) {
		return ApiService.delete(`/sale/delete-suspended/${itemId}`);
	},
	catchErrorToBot(text) {
		let obj = {
			chat_id: '1994816040',
			text: text
		}
		return axios.post(`https://api.telegram.org/bot5292920905:AAHyRXcLPPIY_b4R4btIO91lQxbUS5Yid3E/sendmessage`, obj)
	},
	getKkmSaleList(depId, cashId, payload) {
		return ApiService.get(`/sale/responseEmptyKKM/${depId}/${cashId}?page=${payload.page}&limit=${payload.limit}`)
	},
	getKkmSaleCount(depId, cashId) {
		return ApiService.get(`/sale/responseEmptyKKMCount/${depId}/${cashId}`)
	},
	getPaymentList() {
		return ApiService.get(`/references/payment_type/list`)
	},
	getSaleById(id) {
		return ApiService.get(`/sale/get/${id}`)
	}
};

export default PosService
